<template>
  <div class="esh-theme_parent">
    <h1>THEME - ESH_PARENT</h1>
    <br />
    <a href="/">Home</a>
    <br />
    <v-toolbar height="22">
      <v-toolbar-items>
        <v-btn
          text
          to="/"
        >Home</v-btn>
        <v-btn
          text
          to="/ui-esh"
        >THEME - ESH</v-btn>
        <v-btn
          text
          to="/ui-esh-parent"
        >THEME - ESH-PARENT</v-btn>
        <v-btn
          text
          to="/"
        >Start Page</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <span class="v-toolbar__divider"></span>
    <br />
    <h1>Текст</h1>
    <h2>Текст</h2>
    <h3>Текст</h3>
    <h4>Текст</h4>
    <h5>Текст</h5>
    <h6>Текст</h6>
    <p>строка</p>
    <Table
      class="elevation-1"
      :headers="headers"
      :items="item"
      hide-default-footer
    >
      <template v-slot:item>
        <tr>
          <td>
            <v-btn class="">Текст</v-btn>
          </td>
          <td>
            <v-btn disabled>Текст</v-btn>
          </td>
          <td>
            <v-btn
              class=""
              color="primary"
            >Текст</v-btn>
          </td>
          <td>
            <v-btn
              class=""
              color="error"
            >Текст</v-btn>
          </td>
        </tr>
        <tr>
          <td>
            <v-checkbox
              v-model="valueCheck"
              :label="`Checkbox 1: `"
            ></v-checkbox>
          </td>
          <td>
            <v-checkbox
              v-model="valueCheck"
              disabled
              :label="`Checkbox 1: `"
            ></v-checkbox>
          </td>
          <td>
            <v-checkbox
              v-model="valueCheck"
              readonly
              :label="`Checkbox 1: `"
            ></v-checkbox>
          </td>
          <td>
            <v-checkbox
              v-model="valueCheck"
              :label="`Checkbox 1: `"
            ></v-checkbox>
          </td>
        </tr>
        <tr>
          <td>
            <v-radio-group>
              <v-radio
                :label="`Radio 1`"
                :value="true"
              ></v-radio>
            </v-radio-group>
          </td>
          <td>
            <v-radio
              disabled
              :label="`Radio 1`"
              :value="true"
            ></v-radio>
          </td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>
            <v-switch
              v-model="valueCheck"
              :label="`Switch 1: `"
            ></v-switch>
          </td>
          <td>
            <v-switch
              v-model="valueCheck"
              disabled
              :label="`Switch 1: `"
            ></v-switch>
          </td>
          <td>
            <v-switch
              v-model="valueCheck"
              error
              :label="`Switch 1: `"
            ></v-switch>
          </td>
          <td>
            <v-switch
              v-model="valueCheck"
              :label="`Switch 1: `"
            ></v-switch>
          </td>
        </tr>
        <tr>
          <td>
            <v-text-field
              label="Regular"
              placeholder="Placeholder"
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              label="Regular"
              disabled
              placeholder="Placeholder"
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              label="Regular"
              error
              placeholder="Placeholder"
            ></v-text-field>
          </td>
          <td>
            <v-text-field
              label="Regular"
              placeholder="Placeholder"
            ></v-text-field>
          </td>
        </tr>
        <tr>
          <td>
            <v-select
              :items="items"
              label="SELECT"
            ></v-select>
          </td>
          <td>
            <v-select
              :items="items"
              disabled
              label="SELECT"
            ></v-select>
          </td>
          <td>
            <v-select
              :items="items"
              error
              label="SELECT"
            ></v-select>
          </td>
          <td>
            <v-select
              :items="items"
              color="error"
              label="SELECT"
            ></v-select>
          </td>
        </tr>
        <tr>
          <td>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Дата с:"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                class="esh-parent__datepicker"
                v-model="date"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </td>
          <td>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="date"
                  label="Дата по:"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                class="esh-parent__datepicker"
                v-model="date"
                no-title
                scrollable
                disabled
              >
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </td>
          <td></td>
          <td></td>
        </tr>
      </template>
    </Table>
  </div>
</template>

<script>
// @ is an alias to /src
import Table from "@/components/common/tables/Table";

export default {
  name: 'ui',
  components: {
    Table
	},
	data: () => ({
		valueCheck: false,
		headers: [
			{ text: 'Заголовок 1' },
			{ text: 'Заголовок 1' },
			{ text: 'Заголовок 1' },
			{ text: 'Заголовок 1' }
		],
		date: new Date().toISOString().substr(0, 10),
		menu: false,
		item: [
			{
				name: 'Frozen Yogurt',
				calories: 159,
				fat: 6.0,
				carbs: 24,
				protein: 4.0,
				iron: '1%'
			}
		],
		items: ['Foooooooooooooooooooooooooo', 'Bar', 'Fizz', 'Buzz']
	})
}
</script>
